import { createSlice } from "@reduxjs/toolkit";

export const itemContextSlice = createSlice({
    name: 'itemContext',
    initialState: {
        item: null,
        tag: null,
    },
    reducers: {
        setItem: (state, action) => {
            state.item = action.payload;
        },
        clear: (state) => {
            state.item = null;
        },
        addUserAction: (state, action) => {
            state.item = action.payload.item;
        },
        likeItem: (state) => {
            state.item.count = state.item.count + 1;
            state.item.likedByUser = true;
        },
        unlikeItem: state => {
            state.item.count = state.item.count - 1;
            state.item.likedByUser = false;
        },
    }
});

export const { setItem, clear, addUserAction, likeItem, unlikeItem } = itemContextSlice.actions;
export default itemContextSlice.reducer;